module.exports = __webpack_public_path__ + "ie.svg?deca9e10a3bd63cbb1cc783d2fc85625";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/ie.svg
// module id = 1412
// module chunks = 0